module.exports = __webpack_public_path__ + "img/dashboard-logo.bc1a38aa.svg";